<template>
  <div class="bitts-stepper">
    <BittsButton
      data-testid="decrement-button"
      :disabled="modelValue <= min"
      variant="outline"
      type="neutral"
      size="small"
      :center-icon="['fak', 'minus']"
      @click="decrementModelValue"
    />
    <BittsInput
      name="stepper"
      size="small"
      @update:model-value="restrictInputToNumbers"
      :model-value="String(modelValue)"
      class="max-w-[100px]"
    >
      <template #suffix>
        <div class="text-neutral-text-weak pr-24">
          {{ unit }}
        </div>
      </template>
    </BittsInput>
    <BittsButton
      data-testid="increment-button"
      :disabled="Boolean(max) && modelValue >= Number(max)"
      variant="outline"
      type="neutral"
      size="small"
      :center-icon="['fak', 'add']"
      @click="incrementModelValue"
    />
  </div>
</template>

<script setup lang="ts">
import { Nullable } from '@crossbeam/types';

import BittsButton from '../BittsButton/BittsButton.vue';
import BittsInput from '../BittsInput/BittsInput.vue';

export type Props = {
  modelValue: number;
  min?: number;
  max?: Nullable<number>;
  step?: number;
  unit?: string;
};

const {
  modelValue,
  min = 0,
  max = null,
  step = 1,
  unit,
} = defineProps<Props>();

const emit = defineEmits<(e: 'update:modelValue', value: number) => void>();

function decrementModelValue() {
  emit('update:modelValue', modelValue - step);
}
function incrementModelValue() {
  emit('update:modelValue', modelValue + step);
}
function restrictInputToNumbers(value: string) {
  const numericValue = value.replace(/[^0-9]/g, '');
  let newValue;
  if (!numericValue) newValue = min;
  else {
    const number = Number(numericValue);
    newValue = Math.min(Math.max(number, min), max ?? Infinity);
  }
  emit('update:modelValue', newValue);
}
</script>

<style scoped lang="pcss">
.bitts-stepper {
  @apply flex items-stretch gap-8;
}
:deep(.ant-input) {
  @apply min-w-[16px];
}
</style>
